import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { VexuMark } from './Brand';
interface SlideNavProps {
  slides: string[];
  current: number;
  onSelect: (index: number) => void;
  onPrev: () => void;
  onNext: () => void;
  /** Keeps the edge controls active — used by chapters that exit at the ends. */
  edgeEnabled?: boolean;
}
export function SlideNav({
  slides,
  current,
  onSelect,
  onPrev,
  onNext,
  edgeEnabled = false
}: SlideNavProps) {
  return <div className="pointer-events-none absolute inset-x-0 bottom-0 z-40 flex items-end justify-between px-[42px] pb-[26px]" data-id="element-550" data-mp="2sn6pezls2z1w">
      <div className="flex items-center gap-[16px]" data-id="element-551" data-mp="2eo71ju63ao6s">
        {/* Persistent Vexu signature — present on every slide */}
        <a href="https://vexu.ai" target="_blank" rel="noopener noreferrer" className="pointer-events-auto flex items-center gap-[9px]" data-id="element-552" data-mp="2jn9vojkj79zz">
          <VexuMark size={22} data-id="element-553" data-mp="hu2ibfohb2gq" />
          <span className="text-[11px] font-semibold tracking-[0.12em] text-slate-500 transition-colors duration-200 ease-out hover:text-slate-900" data-id="element-554" data-mp="huc5kvi52viq">
            vexu.ai
          </span>
        </a>

        <span className="h-[12px] w-px bg-slate-200" data-id="element-555" data-mp="1xgg690k48exe" />

        <div className="pointer-events-auto flex items-center gap-[18px] opacity-50 transition-opacity duration-200 ease-out hover:opacity-100" data-id="element-556" data-mp="2b8cugtiny4oi">
        <span className="text-[11px] font-medium tabular-nums tracking-[0.2em] text-slate-500" data-id="element-557" data-mp="277b0ar3lsite">
          {String(current + 1).padStart(2, '0')}
          <span className="text-slate-300" data-id="element-558" data-mp="1eidj6rb4os28">
            {' '}
            / {String(slides.length).padStart(2, '0')}
          </span>
        </span>
        <div className="flex items-center gap-[8px]" data-id="element-559" data-mp="1siwt63z5m871">
          {slides.map((title, index) => <button key={title} type="button" onClick={() => onSelect(index)} aria-label={`Go to ${title}`} aria-current={index === current} className={`h-[3px] rounded-full transition-[width,background-color] duration-200 ease-out ${index === current ? 'w-[26px] bg-vexu-600' : 'w-[12px] bg-slate-300 hover:bg-slate-400'}`} data-id="element-560" data-mp="1nh7f0fgmxeeq" data-mpi={index} />)}
        </div>
        </div>
      </div>

      <div className="pointer-events-auto flex items-center gap-[8px] opacity-40 transition-opacity duration-200 ease-out hover:opacity-100" data-id="element-561" data-mp="2ajsk3xqdc5tj">
        <button type="button" onClick={onPrev} disabled={!edgeEnabled && current === 0} aria-label="Previous slide" className="grid h-[34px] w-[34px] place-items-center rounded-full border border-slate-900/10 bg-white/70 text-slate-600 transition-colors duration-200 ease-out hover:border-slate-900/25 hover:text-slate-900 disabled:opacity-30" data-id="element-562" data-mp="1dvcpvocbd8a3">
          <ChevronLeft className="h-[16px] w-[16px]" data-id="element-563" data-mp="u59a1s846w2t" />
        </button>
        <button type="button" onClick={onNext} disabled={!edgeEnabled && current === slides.length - 1} aria-label="Next slide" className="grid h-[34px] w-[34px] place-items-center rounded-full border border-slate-900/10 bg-white/70 text-slate-600 transition-colors duration-200 ease-out hover:border-slate-900/25 hover:text-slate-900 disabled:opacity-30" data-id="element-564" data-mp="z3u1b25e25f4">
          <ChevronRight className="h-[16px] w-[16px]" data-id="element-565" data-mp="dktlpuclxumm" />
        </button>
      </div>
    </div>;
}